<template>
  <div>
    <custom-dialog class="device-modify-bill-dialog" width="1400px" :title="model.title" :visible="visible" v-on="$listeners" :appendToBody="true">
      <div class="dialog-body">
        <div class="content-box">
          <p class="title" v-if="recoverPwdObj.dataName">
            <span style="margin-bottom: 20px; display: inline-block">{{ recoverPwdObj.dataName }}</span>
            <span>
              <costomWidget
                v-model="recoverPwdObj.dataValue"
                :type="recoverPwdObj.widgetType"
                :isEditWidget="recoverPwdObj.isEditWidget"
                :dicGroup="recoverPwdObj.dicGroup"
                :showUnit="recoverPwdObj.showUnit"
                :dataLen="recoverPwdObj.dataLen"
                :dataType="recoverPwdObj.dataType"
                width="200px"
                scenesType="table"
              ></costomWidget>
            </span>
          </p>
          <p class="title" v-if="endRentDateObj.dataName" style="margin-left: 24px">
            <span style="margin-bottom: 20px; display: inline-block">{{ endRentDateObj.dataName }}</span>
            <span>
              <costomWidget
                v-model="endRentDateObj.dataValue"
                :type="endRentDateObj.widgetType"
                :isEditWidget="endRentDateObj.isEditWidget"
                :dicGroup="endRentDateObj.dicGroup"
                :showUnit="endRentDateObj.showUnit"
                :dataLen="endRentDateObj.dataLen"
                :dataType="endRentDateObj.dataType"
                width="200px"
                scenesType="table"
              ></costomWidget>
            </span>
          </p>
        </div>
        <custom-table
          :data="billContentList"
          :loading="isLoading"
          tableCode="modifyBill"
          @filter="filterChange"
          @sort="sortChange"
          :slots="['billCode', 'billNum', 'receivableOrg', 'billPaymentTime', 'billStartDate', 'billEndDate', 'deferredDuration', 'deferredDate', 'unlockPwd', 'paid', 'action']"
        >
          <template v-slot:billCode="scope">
            <costomWidget
              v-model="scope.row.billCode"
              :type="paramTableColumnObj.billCode.widgetType"
              :isEditWidget="paramTableColumnObj.billCode.isEditWidget"
              :dicGroup="paramTableColumnObj.billCode.dicGroup"
              :showUnit="paramTableColumnObj.billCode.showUnit"
              :dataLen="paramTableColumnObj.billCode.dataLen"
              :dataType="paramTableColumnObj.billCode.dataType"
              width="100%"
              scenesType="table"
            ></costomWidget>
          </template>
          <template v-slot:billNum="scope">
            <costomWidget
              v-model="scope.row.billNum"
              :type="paramTableColumnObj.billNum.widgetType"
              :isEditWidget="paramTableColumnObj.billNum.isEditWidget"
              :dicGroup="paramTableColumnObj.billNum.dicGroup"
              :showUnit="paramTableColumnObj.billNum.showUnit"
              :dataLen="paramTableColumnObj.billNum.dataLen"
              :dataType="paramTableColumnObj.billNum.dataType"
              width="100%"
              scenesType="table"
            ></costomWidget>
          </template>
          <template v-slot:receivableOrg="scope">
            <costomWidget
              v-model="scope.row.receivableOrg"
              :type="paramTableColumnObj.receivableOrg.widgetType"
              :isEditWidget="paramTableColumnObj.receivableOrg.isEditWidget"
              :dicGroup="paramTableColumnObj.receivableOrg.dicGroup"
              :showUnit="paramTableColumnObj.receivableOrg.showUnit"
              :dataLen="paramTableColumnObj.receivableOrg.dataLen"
              :dataType="paramTableColumnObj.receivableOrg.dataType"
              width="100%"
              scenesType="table"
            ></costomWidget>
          </template>
          <template v-slot:billPaymentTime="scope">
            <costomWidget
              v-model="scope.row.billPaymentTime"
              :type="paramTableColumnObj.billPaymentTime.widgetType"
              :isEditWidget="paramTableColumnObj.billPaymentTime.isEditWidget"
              :dicGroup="paramTableColumnObj.billPaymentTime.dicGroup"
              :showUnit="paramTableColumnObj.billPaymentTime.showUnit"
              :dataLen="paramTableColumnObj.billPaymentTime.dataLen"
              :dataType="paramTableColumnObj.billPaymentTime.dataType"
              width="100%"
              scenesType="table"
              @change="onDeferredDuration(scope.row)"
            ></costomWidget>
          </template>
          <template v-slot:billStartDate="scope">
            <costomWidget
              v-model="scope.row.billStartDate"
              :type="paramTableColumnObj.billStartDate.widgetType"
              :isEditWidget="paramTableColumnObj.billStartDate.isEditWidget"
              :dicGroup="paramTableColumnObj.billStartDate.dicGroup"
              :showUnit="paramTableColumnObj.billStartDate.showUnit"
              :dataLen="paramTableColumnObj.billStartDate.dataLen"
              :dataType="paramTableColumnObj.billStartDate.dataType"
              width="100%"
              scenesType="table"
            ></costomWidget>
          </template>
          <template v-slot:billEndDate="scope">
            <costomWidget
              v-model="scope.row.billEndDate"
              :type="paramTableColumnObj.billEndDate.widgetType"
              :isEditWidget="paramTableColumnObj.billEndDate.isEditWidget"
              :dicGroup="paramTableColumnObj.billEndDate.dicGroup"
              :showUnit="paramTableColumnObj.billEndDate.showUnit"
              :dataLen="paramTableColumnObj.billEndDate.dataLen"
              :dataType="paramTableColumnObj.billEndDate.dataType"
              width="100%"
              scenesType="table"
            ></costomWidget>
          </template>
          <template v-slot:deferredDuration="scope">
            <div style="width: 70%; display: inline-block">
              <costomWidget
                v-model="scope.row.deferredDuration"
                :type="paramTableColumnObj.deferredDuration.widgetType"
                :isEditWidget="paramTableColumnObj.deferredDuration.isEditWidget"
                :dicGroup="paramTableColumnObj.deferredDuration.dicGroup"
                :showUnit="paramTableColumnObj.deferredDuration.showUnit"
                :dataLen="paramTableColumnObj.deferredDuration.dataLen"
                :dataType="paramTableColumnObj.deferredDuration.dataType"
                width="100%"
                scenesType="table"
                @change="onDeferredDuration(scope.row)"
              ></costomWidget>
            </div>
            <span style="vertical-align: sub; margin-left: 5px">
              {{ showUnit }}
              <!-- {{getDicValue('iot_tsl_data_unit',showUnit)}} -->
            </span>
          </template>
          <template v-slot:deferredDate="scope">
            <costomWidget
              v-model="scope.row.deferredDate"
              :type="paramTableColumnObj.deferredDate.widgetType"
              isEditWidget="0"
              :dicGroup="paramTableColumnObj.deferredDate.dicGroup"
              :showUnit="paramTableColumnObj.deferredDate.showUnit"
              :dataLen="paramTableColumnObj.deferredDate.dataLen"
              :dataType="paramTableColumnObj.deferredDate.dataType"
              width="100%"
              scenesType="table"
            ></costomWidget>
          </template>
          <template v-slot:unlockPwd="scope">
            <costomWidget
              v-model="scope.row.unlockPwd"
              :type="paramTableColumnObj.unlockPwd.widgetType"
              :isEditWidget="paramTableColumnObj.unlockPwd.isEditWidget"
              :dicGroup="paramTableColumnObj.unlockPwd.dicGroup"
              :showUnit="paramTableColumnObj.unlockPwd.showUnit"
              :dataLen="paramTableColumnObj.unlockPwd.dataLen"
              :dataType="paramTableColumnObj.unlockPwd.dataType"
              width="100%"
              scenesType="table"
            ></costomWidget>
          </template>
          <template v-slot:paid="scope">
            <costomWidget
              v-model="scope.row.paid"
              :type="paramTableColumnObj.paid.widgetType"
              :isEditWidget="paramTableColumnObj.paid.isEditWidget"
              :dicGroup="paramTableColumnObj.paid.dicGroup"
              :showUnit="paramTableColumnObj.paid.showUnit"
              :dataLen="paramTableColumnObj.paid.dataLen"
              :dataType="paramTableColumnObj.paid.dataType"
              width="100%"
              scenesType="table"
            ></costomWidget>
          </template>
          <template v-slot:action="scope">
            <div class="icon-box">
              <el-button type="text" size="mini" @click="deleteBillItem(scope.row.billNum)">{{ $t('Common.com_delete') }}</el-button>
            </div>
          </template>
        </custom-table>
        <div class="add-bill-btn" @click="addBillBtn()">
          <div style="display: inline-block">
            <i class="icon icon-add"></i>
            <span>{{ $t('Common.com_added') }}</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveBillStatus">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';
import costomWidget from '@/components/customWidget';

export default {
  props: {
    data: [String, Object, Array],
    model: {
      type: Object,
      default() {
        return {
          type: '', // add、edit
          title: '',
        };
      },
    },
  },
  components: {
    costomWidget,
  },
  data() {
    return {
      visible: true,
      tableCode: 'modifyBill',
      tslCodeList: [],
      billContent: [],
      billContentList: [],
      paramTableColumn: [],
      paramTableColumnObj: {},
      // 账单结束日期,账单开始日期,延期付款日期
      dateColumn: ['billEndDate', 'billStartDate', 'deferredDate', 'billPaymentTime'],
      minColumn: ['billCode', 'billNum'],
      bodyNum: '',
      componentCode: '',
      topicId: '',
      // 空对象
      listItem: {},
      // periodNum: "",

      iot_tsl_data_unit: {},
      recoverPwdObj: {},
      endRentDateObj: {},
      showUnit: '',
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.bodyNum = this.data.bodyNum;
      this.componentCode = this.data.componentCode;
      // this.getParamList();
      this.getBillList();
    },
    getBillList: function () {
      // this.$getJSON(apis.DeviceResumeParamItemList, {
      this.$getJSON(apis.DeviceResumeParamItemLastArchive, {
        bodyNum: this.bodyNum,
        componentCode: this.componentCode,
      }).then((res) => {
        // 编辑合并值和新的未填入值
        const billContent = res.data.filter(i => i.dataCode === 'billContent');
        this.billContent = billContent[0];
        this.topicId = this.billContent.topicId;
        const widgetTypeList = res.data.filter(
          i => i.dataCode !== 'billContent' && i.dataCode !== 'periodNum' && i.dataCode !== 'uploadTime' && i.dataCode !== 'recoverPwd' && i.dataCode !== 'endRentDate'
        );

        // 延迟单位
        const deferredDuration = res.data.find(i => i.dataCode === 'deferredDuration');
        this.showUnit = deferredDuration && deferredDuration.showUnit;
        // this.billContentList = JSON.parse(this.billContent.dataValue);
        // this.billContentList = (this.billContent.dataValue
        //     && JSON.parse(this.billContent.dataValue))
        //   || [];
        this.billContentList = this.billContent.dataValue || [];
        this.billContentList.forEach((item) => {
          this.onDeferredDuration(item);
        });
        // 支付状态转 字符串
        this.billContentList.forEach((i) => {
          i.paid = `${i.paid}`;
        });

        widgetTypeList.forEach((i) => {
          // 设置表格列
          let column = {};
          column = i;
          column.columnCode = i.dataCode;
          column.columnName = i.dataName;
          column.widgetType = i.widgetType;
          this.paramTableColumn.push(column);
          this.paramTableColumnObj[i.columnCode] = column;
        });

        // 回收密码
        this.recoverPwdObj = res.data.find(i => i.dataCode === 'recoverPwd') || {};
        // 终止租赁时间
        this.endRentDateObj = res.data.find(i => i.dataCode === 'endRentDate') || {};
        this.paramTableColumn.forEach((i) => {
          // console.log(i)
          const obj = {};
          obj[i.dataCode] = '';

          // 延期付款时长默认0
          obj.deferredDuration = 0;
          // 支付状态默认未支付
          obj.paid = '0';

          Object.assign(this.listItem, obj);

          // return obj
        });

        // 整理序号
        this.billNumCalcula();
      });
    },
    // 添加期数
    addBillBtn: function () {
      // 账单开始日期默认上期的结束日期
      if (this.billContentList.length) {
        this.listItem.billStartDate = this.billContentList[this.billContentList.length - 1].billEndDate || '';
      }
      this.billContentList.push(JSON.parse(JSON.stringify(this.listItem)));
      this.billNumCalcula();
    },
    // 删除账单
    deleteBillItem: function (billNum) {
      const index = this.billContentList.findIndex(i => i.billNum === billNum);
      this.billContentList.splice(index, 1);
      this.billNumCalcula();
    },
    // 计算期数
    billNumCalcula() {
      this.billContentList.forEach((item, index) => {
        item.billNum = index + 1;
      });
    },
    // 计算付款日期
    onDeferredDuration(item) {
      if (item.billPaymentTime && item.deferredDuration) {
        if (this.showUnit === 'h') {
          item.deferredDate = moment(item.billPaymentTime).add(item.deferredDuration, 'hours').utc().format();
        } else {
          item.deferredDate = moment(item.billPaymentTime).add(item.deferredDuration, 'days').utc().format();
        }
      } else {
        item.deferredDate = moment(item.billPaymentTime).add(0, 'days').utc().format();
      }
    },
    // 保存基本信息
    saveBillStatus: function () {
      // 延期0天自动添加补齐延期时间
      this.billContentList.forEach((item) => {
        this.onDeferredDuration(item);
      });
      // 判断账单值不准为空
      const hasEmpty = this.billContentList.find((bill) => {
        // 账单延迟日期有可能是0天
        const empty = this.paramTableColumn.find(i => !bill[i.columnCode] && bill[i.columnCode] !== 0);
        return empty;
      });

      // 账单解锁密码 长度是6位
      const hasUnlockPwdlength = this.billContentList.find(item => +item.unlockPwd < 100000 || +item.unlockPwd > 999999);
      // 回收密码 长度是6位
      const hasRecoverPwdlength = !this.recoverPwdObj.dataValue || this.recoverPwdObj.dataValue < 100000 || this.recoverPwdObj.dataValue > 999999;
      // 账单解锁密码和回收密码不能相同
      const hasRepeatPwd = this.billContentList.find(item => item.unlockPwd === this.recoverPwdObj.dataValue);
      // 终止租赁时间
      const hasEndRentDateEmpty = !this.recoverPwdObj.dataValue;
      // 账单结束时间早于开始时间
      const hasBillEndDateEarlier = this.billContentList.find(item => item.billEndDate < item.billStartDate);
      // 账单需付款要在账单开始和结束日期之间
      const hasBillPaymentTime = this.billContentList.find(
        item => moment(item.billPaymentTime).isBefore(moment(item.billStartDate)) || moment(item.billPaymentTime).isAfter(moment(item.billEndDate))
      );

      // 密码重复 查每一项的密码
      let nodeArr = [];
      const hasUnlockPwdDuplicate = this.billContentList.find((item) => {
        let res;
        if (nodeArr.length > 0) {
          res = nodeArr.find(pitem => +item.unlockPwd === +pitem.unlockPwd);
        }
        nodeArr.push(item);
        return res;
      });
      if (hasEmpty || hasUnlockPwdlength || hasRecoverPwdlength || hasEndRentDateEmpty || hasRepeatPwd || hasBillEndDateEarlier || hasBillPaymentTime || hasUnlockPwdDuplicate) {
        if (hasEmpty) {
          const tips = this.$t('dms_device_modifyBill_dialog.qbcstxwz');
          this.$message.error(tips);
        } else if (hasUnlockPwdlength) {
          const tips = this.$t('dms_device_modifyBill_dialog.zdjsmmxw6wsz');
          this.$message.error(tips);
        } else if (hasRecoverPwdlength) {
          const tips = this.$t('dms_device_modifyBill_dialog.shmmxw6wsz');
          this.$message.error(tips);
        } else if (hasEndRentDateEmpty) {
          const tips = this.$t('dms_device_modifyBill_dialog.qxzzzzlsj');
          this.$message.error(tips);
        } else if (hasRepeatPwd) {
          const tips = this.$t('dms_device_modifyBill_dialog.zdmmyhsmmbncf');
          this.$message.error(tips);
        } else if (hasBillEndDateEarlier) {
          const tips = this.$t('dms_device_modifyBill_dialog.zdjssjbnzyzdkssj');
          this.$message.error(tips);
        } else if (hasBillPaymentTime) {
          const tips = this.$t('dms_device_modifyBill_dialog.zdxfkrqyzzqhzdjsrqzj');
          this.$message.error(tips);
        } else if (hasUnlockPwdDuplicate) {
          const tips = this.$t('dms_device_modifyBill_dialog.zdjsmmbncf');
          this.$message.error(tips);
          nodeArr = [];
        }
      } else {
        // 多个对象合并数组
        // const paramList = this.billContentList.map((bill) => {
        //   const arr = [];
        //   this.paramTableColumn.forEach((column) => {
        //     const billPar = {};
        //     // const billPar = {...column};
        //     billPar[column.columnCode] = bill[column.columnCode] || '';
        //     // 传topocCode
        //     // billPar.topicCode = this.data.topicCode;
        //     arr.push(billPar);
        //   });
        //   return arr;
        // });
        // 期数
        let num = 0;
        // 每期重新组合格式
        const taskOrders = this.billContentList.map((i) => {
          ++num;
          const obj = {};
          obj.paramKey = 'billContent';
          // obj.paramValue = JSON.stringify(i);
          obj.paramValue = i;

          obj.paramName = this.billContent.dataName;
          obj.dataType = this.billContent.dataType;
          obj.tslDataId = this.billContent.tslDataId;
          obj.tslCode = this.billContent.tslCode;
          // obj.=this.billContent
          // const paramItem=this.paramTableColumn.find(i=>i.)
          // console.log(JSON.stringify(i), i);
          // return JSON.stringify(obj);
          return obj;
        });
        taskOrders.push({ paramKey: 'periodNum', paramValue: num });
        const recoverPwdObjValue = +this.recoverPwdObj.dataValue;
        taskOrders.push({
          paramKey: 'recoverPwd',
          paramValue: recoverPwdObjValue,
        });
        // 新加的
        const endRentDateObjValue = this.endRentDateObj.dataValue;
        taskOrders.push({
          paramKey: 'endRentDate',
          paramValue: endRentDateObjValue,
        });
        const sumbitParms = {};
        sumbitParms.bodyNum = this.data.bodyNum;
        // sumbitParms.componentCode = this.data.componentCode;
        sumbitParms.topicCode = this.data.componentCode;
        sumbitParms.componentId = this.data.componentId;
        sumbitParms.dataList = taskOrders;
        sumbitParms.topicId = this.topicId;
        this.$postJSON(apis.DeviceResumeParamItemSaveBill, sumbitParms).then(() => {
          this.$message({
            message: this.$t('Common.com_modify_success'),
            type: 'success',
          });
          this.closeDialog();
          this.$emit('success');
        });
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close');
      }, 250);
    },
  },
};
</script>

<style lang="scss">
.device-modify-bill-dialog {
  // .title {
  //   color: #000000;
  //   font-weight: bold;
  //   font-size: 14px;
  //   margin-bottom: 15px;
  // }

  .content-box {
    display: flex;
    .title {
      // height: 28px;
      margin-bottom: 24px;
      font-weight: bold;
      font-size: 12px;
      color: rgba(73, 80, 87, 1);
      // line-height:28px;
    }
  }
  .bill-list {
    // flex: 1;
    // height: 0;
    max-height: 100%;
    overflow-y: auto;
    ul li {
      // margin-top: 10px;
      // margin-bottom: 10px;
      // border: 1px solid rgba(228, 228, 228, 1);
      &:first-child {
        margin-top: 0;
      }
    }
    .rule-label {
      height: 30px;
      line-height: 30px;
      background: rgba(228, 228, 228, 1);
      color: #212121;
      font-size: 12px;
      padding: 0 10px;
    }
    .bill-item {
      padding: 5px 16px;
      // background: rgba(245, 245, 245, 1);
      border-bottom: 1px solid #eef2f8;
      color: #6c757d;
      .num {
        height: 32px;
        line-height: 32px;
      }
      .icon-box {
        line-height: 30px;
        width: 60px;
        margin-left: 10px;
        text-align: center;
        .icon {
          color: #00afff;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
    .bill-thead {
      padding: 0 16px;
      margin: 0;
      height: 44px;
      line-height: 44px;
      font-size: 12px;
      background: rgba(242, 243, 251, 1);
      // background: rgba(245, 245, 245, 1);
      border-bottom: 1px solid #eef2f8;
      font-weight: 500;
      color: rgba(99, 110, 120, 1);
      .num {
        height: 44px;
        line-height: 44px;
      }
    }
  }
  .add-bill-btn {
    background: rgba(245, 245, 245, 1);
    border: 1px dashed rgba(228, 228, 228, 1);
    line-height: 30px;
    text-align: center;
    color: #333333;
    font-size: 12px;
    margin: 20px 10px 0;
    cursor: pointer;
    .icon {
      color: #00afff;
      font-size: 10px;
      margin-right: 8px;
      float: left;
    }
  }
}
</style>
